import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import {IconButton} from "@mui/material";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const clickableField = (field) => (evt) => {
    evt.preventDefault();
    if(field.readOnly) return;
    field.setValue(field.name, (v) => { return !v; });
};

export function FieldTableBooleanColumn(): ReactElement {
    const context = useContext(FieldTableSettingsContext);
    useEffect(() => {
        if(!context) return;
        context.registerType({
            dataType: 'boolean',
            width: () => 'minmax(8em,max-content)',
            className: () => 'column-centered column-button',
            // eslint-disable-next-line react/display-name
            renderViewer: (props: FieldRendererProps<any,any>) => {

                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                return (<IconButton className="uneditable" onClick={clickableField(props.field)}>{value?<CheckBoxIcon/>:<CheckBoxOutlineBlankIcon/>}</IconButton>);
            },
            // eslint-disable-next-line react/display-name
            renderEditor: (props: FieldRendererProps<any,any>) => {
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                if (props.options?.editor) {
                    return props.options.editor(props);
                }
                return <IconButton className="uneditable" autoFocus={true} onClick={clickableField(props.field)} >{value?<CheckBoxIcon/>:<CheckBoxOutlineBlankIcon/>}</IconButton>
            },
            renderExport:(cell,props: FieldRendererProps<any,any>):any => {
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                cell.v = value ? 'Y' : 'N';
                return cell;
            }
        });
    }, [context]);
    return null;
}
